import { BaseModel } from './BaseModel';

export class CatalogEntry extends BaseModel {
    public sourceKey = '';
    public sourceId = '';
    public sourceLabel = '';
    public sourceVerified = false;
    public sourceUrl = '';
    public sourceViewUrl: string | null = null;
    public sourceHash = '';
    public name = '';
    public description: string | null = null;
    public category: string | null = null;
    public weight = 0;
    public linkedEggId: number | null = null;
    public linkedNestId: number | null = null;
    public linkedDetached = false;
    public linkedSyncedAt: string | null = null;
    public updateAvailable = false;

    getRouteName(): string {
        return 'catalog_entry';
    }

    getRouteID(): string {
        return `${this.sourceKey}:${this.sourceId}`;
    }
}
